import { channelsConstants } from '@constants/channels';

const initialState = {
    data: [],
    loading: true,
    error: '',
    whatsAppBusinessPhoneNumbers: [],
    whatsAppBusinessPhoneNumbersLoading: false,
    whatsAppBusinessTemplates: [],
};

export function channels(state = initialState, action) {
    switch (action.type) {
        case channelsConstants.CHANNELS_FETCH:
            return { ...state, loading: true, error: '' };
        case channelsConstants.CHANNELS_SUCCESS:
            return { ...state, loading: false, data: action.data };
        case channelsConstants.CHANNELS_ERROR:
            return { ...state, error: action.message, loading: false };
        case channelsConstants.CHANNELS_UPDATE:
            return { ...state, data: action.data, loading: false };
        case channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_FETCH:
            return { ...state, whatsAppBusinessPhoneNumbersLoading: true };
        case channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_SUCCESS:
            return {
                ...state,
                whatsAppBusinessPhoneNumbers: action.payload,
                whatsAppBusinessPhoneNumbersLoading: false,
            };
        case channelsConstants.WHATSAPP_BUSINESS_PHONE_NUMBERS_ERROR:
            return { ...state, whatsAppBusinessPhoneNumbers: [], whatsAppBusinessPhoneNumbersLoading: false };
        case channelsConstants.WHATSAPP_BUSINESS_TEMPLATES_SUCCESS:
            return { ...state, whatsAppBusinessTemplates: action.payload };
        case channelsConstants.WHATSAPP_BUSINESS_TEMPLATES_ERROR:
            return { ...state, whatsAppBusinessTemplates: [] };
        default:
            return state;
    }
}
